import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CSSBuySheetGuide from "../pages/cssbuy-sheet-guide/page";
import CSSBuySheetShoppingGuide from "../pages/cssbuy-sheet-shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-sheet-guide",
    element: <CSSBuySheetGuide />,
  },
  {
    path: "/cssbuy-sheet-shopping-guide",
    element: <CSSBuySheetShoppingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;